<template>
  <section class="main-container">
    <div class="columns flex-reverse-mobile">
      <div class="column">
        <h3 class="title is-spaced">          
          {{ box.name }}          
        </h3>

        <p class="desc has-margin-bottom-2" style="white-space: pre-line;">{{ box.description }}</p>

        <h5 class="subtitle" v-if="box.beneficiaries">A qui es dirigeix?</h5>
        <p class="desc has-margin-bottom-2" style="white-space: pre-line;">{{ box.beneficiaries }}</p>

        <!-- <h5 v-if="box.offer" class="subtitle">Recursos que aporta a la comunitat</h5>
        <p v-if="box.offer" class="desc has-margin-bottom-2" style="white-space: pre-line;">{{ box.offer }}</p> -->

        <h5 v-if="box.demand" class="subtitle">Suport que sol·licita</h5>
        <p v-if="box.demand" class="desc has-margin-bottom-2" style="white-space: pre-line;">{{ box.demand }}</p>

        <!-- <button @click="contact" class="call-button button is-danger has-margin-bottom-3" style="line-height:40px;height:auto">
          Per aportar a aquesta iniciativa <br>posa't en contacte amb el projecte
        </button> -->
        
      </div>
      <div class="column is-one-third">
        <div class="is-full text-center">
        <button v-if="box.demand != ''" @click="contact" class="call-button button is-danger has-margin-bottom-2" style="line-height:40px;height:auto">
          Per aportar a aquesta iniciativa <br>posa't en contacte amb el projecte
        </button>
        <button v-if="box.demand == ''" @click="contact" class="call-button button is-danger has-margin-bottom-2" style="line-height:40px;height:auto">
          Posa't en contacte amb el projecte
        </button>
        </div>
        <h3 class="subtitle subtitle-name">{{ box.user ? box.user.name : '-' }}</h3>
        <ul class="info">          
          <li class="has-text-right">
            Sector {{ box.scope || '-' | scopeDescription }}
            <i class="material-icons">group_work</i>
          </li>
                
          <li class="has-text-right" v-if="box.city">
            <span class="text">
              {{ box.city }} {{ box.territorial ? '(' : '' }}{{ box.territorial | territorialDescription }}{{ box.territorial ? ')' : '' }}
              <i class="material-icons">location_on</i>
            </span>
          </li>   
          <li class="has-text-right" v-if="box.phone">
            <span class="text">
              <a class="has-text-danger" :href="'tel:' + box.phone">{{ box.phone }}</a>              
              <i class="material-icons">call</i>
            </span>
          </li>   
          <li class="has-text-right" v-if="box.email">
            <span class="text">              
              <span v-linkified:options="{ className: 'has-text-danger' }" v-html="box.email"></span>
              <i class="material-icons">email</i>
            </span>
          </li>             
          <li class="has-text-right" v-if="box.web">
            <span class="text">              
              <span v-linkified:options="{ className: 'has-text-danger' }" v-html="box.web"></span>
              <i class="material-icons">http</i>
            </span>
          </li>
          <li class="has-text-right" v-if="box.whatsapp">
            <span class="text">
              <a class="has-text-danger" :href="'tel:' + box.whatsapp">{{ box.whatsapp }}</a>
              <i class="fa fa-whatsapp"></i>
            </span>
          </li>              
                            
          <li class="has-text-right" v-if="box.instagram">
            <span class="text">
              <span v-linkified:options="{ className: 'has-text-danger' }" v-html="box.instagramHref ? box.instagramHref : box.instagram"></span>              
              <i class="fa fa-instagram"></i>
            </span>
          </li>                    
          <li class="has-text-right" v-if="box.twitter">
            <span class="text">              
              <span v-linkified:options="{ className: 'has-text-danger' }" v-html="box.twitterHref ? box.twitterHref : box.twitter"></span>
              <i class="fa fa-twitter"></i>
            </span>
          </li>                  
          <li class="has-text-right" v-if="box.facebook">
            <span class="text">
              <span v-linkified:options="{ className: 'has-text-danger' }" v-html="box.facebookHref ? box.facebookHref : box.facebook">{{ box.facebook }}</span>
              <i class="fa fa-facebook"></i>
            </span>
          </li>                    
        </ul>
        <p class="desc mt-2" v-if="boxUser.description">
          {{ boxUser.description }}
        </p>

        <ul class="info info-buttons" v-if="currentUser">
          
          <li v-if="currentUser && box.userId == currentUser.uid" class="text-center admin-buttons">
            <button class="button is-danger" @click="editBox" v-if="box.userId == currentUser.uid">Edita</button>
            <button class="button is-danger" @click="deleteBox" v-if="box.userId == currentUser.uid">Esborra</button>
          </li>
          <li v-if="currentUser && userProfile.role == 'admin'" class="text-center admin-buttons">
            <div>ADMIN</div>
            
            <button
              class="button is-danger"
              @click="editBox"
              v-if="(userProfile.role == 'admin')"
            >Edita</button>
            <button
              class="button is-danger"
              @click="deleteBox"
              v-if="userProfile.role == 'admin'"
            >Esborra</button>
            
          </li>
        </ul>
        <!-- <ul class="info info-buttons" v-if="!currentUser">
          
          <li class="text-center admin-buttons">            
            <router-link to="/login" class="button is-primary">Accedeix</router-link>            
            <p class="desc">Accedeix o registra't per accedir als detalls de la necessitat</p>            
          </li>
        </ul> -->
      </div>
    </div>

    <!-- <pre>boxUser:{{ boxUser }}</pre>
            <pre>me:{{ userProfile }}</pre>
    <pre>comments: {{ comments }}</pre>-->
  </section>
</template>

<script>
import { mapState } from "vuex";
import MyBoxes from "@/components/MyBoxes";
import { createNotification } from "../services/notifications.service";
import moment from "moment";
import {
  levelDescription,
  scopeDescription,
  dimensionDescription,
  competenceDescription,
  stateDescription
} from "../services/descriptions.filters";
const fb = require("../firebaseConfig.js");

export default {
  components: {
    MyBoxes,
  },
  data() {
    return {
      boxId: 0,
      box: {},
      boxUser: {},
      showSuccess: false,
      canDownload: false,
      canAccess: false,
      myReviewValue: 0,
      comment: "",
      comments: [],
      publicComments: [],
      privateComments: [],
      selectedMenu: 0
    };
  },
  mounted() {
    if (this.$route.params.id) {
      this.boxId = this.$route.params.id;
      this.viewBox();
    }
  },
  watch: {
    $route(to, from) {
      // react to route changes...
      //console.log("to", to, from);
      if (this.$route.params.id) {
        this.boxId = this.$route.params.id;
        this.viewBox();
      }
    }
  },
  computed: {
    ...mapState(["userProfile", "currentUser"])
  },
  methods: {
    viewBox() {
      //console.log('this.boxId', this.boxId)
      fb.boxesCollection
        .doc(this.boxId)
        .get()
        .then(doc => {
          if (doc.exists) {
            let box = doc.data();
            box.id = doc.id;
            this.box = box;

            if (this.box.facebook != '' && !this.box.facebook.startsWith('http')) {
              this.box.facebookHref = 'facebook.com/' + this.box.facebook.replace('@', '')
            }
            if (this.box.twitter != '' && !this.box.facebook.startsWith('http')) {
              this.box.twitterHref = 'twitter.com/' + this.box.twitter.replace('@', '')
            }
            if (this.box.instagram != '' && !this.box.facebook.startsWith('http')) {
              this.box.instagramHref = 'instagram.com/' + this.box.instagram.replace('@', '')
            }
            
            fb.usersCollection
              .doc(box.userId)
              .get()
              .then(doc => {
                if (doc.exists) {
                  let user = doc.data();
                  user.id = doc.id;
                  this.boxUser = user;
                }
              });

          }
        })
        .catch(err => {
          console.log(err);
        });
    },
    aproveBox() {
      fb.boxesCollection
        .doc(this.boxId)
        .update({
          state: "active"
        })
        .then(doc => {
          let previousState = this.box.state;
          this.box.state = "active";

          if (previousState == "new") {
            console.log("this.userProfile.uploads", this.userProfile.uploads);
            fb.usersCollection
              .doc(this.box.userId)
              .get()
              .then(doc => {
                if (doc.exists) {
                  let user = doc.data();
                  let xp = user.xp;
                  let balance = user.balance;
                  let userLevel = user.userLevel;

                  if (xp >= 15) {
                    userLevel = 2;
                  }
                  if (xp > 15) {
                    userLevel = 3;
                  }

                  fb.usersCollection
                    .doc(this.box.userId)
                    .update({
                      xp: user.xp + userLevel,
                      balance: user.balance + userLevel,
                      userLevel: userLevel
                    })
                    .then(() => {
                      createNotification(
                        "box-approved",
                        this.boxId,
                        { role: "admin" },
                        {
                          userId: this.box.userId,
                          email: this.box.user.email || "",
                          name: this.box.user.name
                        }
                      );

                      this.viewBox();
                    });
                }
              });
          }
        })
        .catch(err => {
          console.log(err);
        });
    },
    downloadBox() {
      this.$swal({
        title: "Descarregar caixa?",
        text: "Podrás accedir al contingut d'aquesta caixa i es restarà 1 punt al teu saldo",
        icon: "question",
        confirmButtonText: "Sí",
        showCancelButton: true,
        cancelButtonText: "No"
      }).then(result => {
        if (result.value) {
          let docId = `${this.currentUser.uid}_${this.boxId}`;

          fb.downloadsCollection
            .doc(docId)
            .get()
            .then(doc => {
              if (doc.exists) {
                return;
              }

              fb.downloadsCollection
                .doc(docId)
                .set({
                  boxId: this.boxId,
                  userId: this.currentUser.uid
                })
                .then(() => {
                  // update post likes
                  fb.boxesCollection.doc(this.boxId).update({
                    downloads: this.box.downloads + 1
                  });

                  fb.usersCollection
                    .doc(this.currentUser.uid)
                    .update({
                      balance: this.userProfile.balance - 1,
                      downloads: this.userProfile.downloads + 1
                    })
                    .then(() => {
                      this.viewBox();
                    });
                });
            })
            .catch(err => {
              console.log(err);
            });
        }
      });
    },
    deleteBox() {
      this.$swal({
        title: "Esborrar necessitat?",
        text: "Estas segur/a?",
        icon: "question",
        confirmButtonText: "Sí",
        showCancelButton: true,
        cancelButtonText: "No"
      }).then(result => {
        if (result.value) {
          fb.boxesCollection
            .doc(this.boxId)
            .update({
              state: "deleted"
            })
            .then(doc => {
              this.box.state = "deleted";
              this.$router.push("/les-meves-iniciatives");
            })
            .catch(err => {
              console.log(err);
            });
        }
      });
    },    
    editBox() {
      this.$router.push(`/edita/${this.boxId}`);
    },    
    addComment(access) {
      let boxId = this.boxId;
      let boxComments = this.box.comments;

      fb.commentsCollection
        .add({
          createdOn: new Date(),
          content: this.comment,
          boxId: boxId,
          userId: this.currentUser.uid,
          access: access,
          user: {
            name: this.userProfile.name
          }
        })
        .then(doc => {
          fb.boxesCollection
            .doc(boxId)
            .update({
              comments: boxComments + 1
            })
            .then(() => {
              //this.closeCommentModal();
              this.comment = ''
              //this.box.comments++
              this.viewBox();

              this.addNotification(access);
            });
        })
        .catch(err => {
          console.log(err);
        });
    },
    sortByKey(array, key) {
      return array.sort(function(a, b) {
        var x = a[key];
        var y = b[key];
        return x < y ? -1 : x > y ? 1 : 0;
      });
    },    
    addNotification(access){

      let from = {
        userId: this.currentUser.uid,
        name: this.userProfile.name,
        email: this.currentUser.email
      }

      let to = {
        userId: this.box.userId,
        email: this.box.user.email || "",
        name: this.box.user.name
      }

      createNotification("new-comment-" + access, this.boxId, from, to);
    },
    contact(){
      if (this.box.web) {
        if (this.box.web != '' && !this.box.web.startsWith('http')) {          
          window.open('http://' + this.box.web)
        }
        else {
          window.open(this.box.web)
        }        
      }
      else if (this.box.facebookHref) {
        window.open(this.box.facebookHref)
      }
      else if (this.box.instagramHref) {
        window.open(this.box.instagramHref)
      }      
      else if (this.box.twitterHref) {
        window.open(this.box.twitterHref)
      }
    }
  },
  filters: {
    formatDate(val) {
      if (!val) {
        return "";
      }
      return moment.unix(val).format("DD/MM/YYYY");
    },
    formatReview(val) {
      if (!val || val == '-') {
        return "-";
      }
      return Math.round(val * 10) / 10
    }
  }
};
</script>
<style scoped>
p.desc {
  font-size: 16px;
  color: #a3a3a3;
  line-height: 30px;
}
.title {
  margin-bottom: 2.5rem;
}
.subtitle {
  margin-top: 1.5rem;
  font-weight: bold;
  color: #363636;
}
ul.info {
  background: #f9f9f9;
  border: 2px solid #f1f1f1;
  border-bottom: 0;
}
ul.info li {
  border-bottom: 2px solid #dbdbdb;
  border-bottom: 2px solid #f1f1f1;
  padding: 12px 12px;
  font-size: 16px;
  font-family: "Varela Round";
  color: #727475;
  color: #a3a3a3;
  line-height: 30px;
}
ul.info .material-icons {
  vertical-align: -7px;
  margin-left: 10px;
}
ul.info .text {
  text-align: right;
  display: inline-block;
}
ul.info .text-center {
  text-align: center;
}
ul.info .admin-buttons button {
  margin-bottom: 0.5rem;
}
ul.info-buttons {
  background: none;
  border: 0;
}
ul.info-buttons li {
  border: 0;
}
.reviews {
  color: #a3a3a3;
  font-family: "Varela Round";
}
.title.has-margin-bottom-1 {
  margin-bottom: 1rem !important;
}
.is-full {
  width: 100%;
}
ul.menu {
  border-bottom: 2px solid #f1f1f1;
}
nav.level {
  border-bottom: 2px solid #f1f1f1;
}
.level-item {
  color: #727475;
  padding: 20px;
  cursor: pointer;
}
.selected-menu {
  box-shadow: 0 2px 0 #ffb72f;
}
.tu-tag {
  margin-right: 6px;
}
.box {
  background-color: #34495e;
}
.comment-text {
  margin-bottom: 1.5rem;
  line-height: 22px !important;
}
p .date {
  color: #727475;
  padding-left: 10px;
}
.title .tag {
  text-transform: uppercase;
  font-weight: normal;
  font-family: "Varela Round";
}
.subtitle-name{
  font-family: "Varela Round";
  font-size: 30px;
  text-align: center;
  margin-top: 0;
}
table.links td.link span{
  margin-left: 90px;
  display: inline-block;
}
.mt-2{
  margin-top: 2rem;
}
ul.info .fa{
margin-left: 10px;
font-size: 24px;
vertical-align: -2px;
}
.call-button{
  max-width: 100%;
}
</style>


// WEBPACK FOOTER //
// src/components/Box.vue